<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData">
      <template #handle>
        <!-- <el-form-item>
          <el-button type="danger" icon="el-icon-download" @click="setOtaIsShow">{{$t('eIoT.transmit.batchDownload')}}</el-button>
        </el-form-item> -->
      </template>
    </Filter>
    <!-- select -->
    <Table
      :tableData="tableDataList"
      :total="total"
      @update="updatePage"
      :selectable="selectable"
      @select="handleSelect"
    >
      <!-- <el-table-column prop="robotModel" :label="$t('eIoT.transmit.robotModel')" /> -->
      <el-table-column prop="robotSn" :label="$t('eIoT.transmit.robotCode')" />
      <!-- <el-table-column prop="robotName" :label="$t('eIoT.transmit.robotName')">
        <template #default="scope">
          {{ scope.row.robotName || scope.row.robotSn }}
        </template>
      </el-table-column> -->
      <el-table-column prop="endTool" :label="$t('eIoT.transmit.endTool')">
        <template #default="scope">
          {{ endToolMap[scope.row.endTool] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="fileName"
        :label="$t('eIoT.transmit.dataPackageName')"
        width="250px"
      />
      <el-table-column
        prop="taskId"
        :label="'任务ID' || $t('eIoT.transmit.taskId')"
      />
      <el-table-column
        prop="fileName"
        :label="$t('eIoT.transmit.taskTypeName')"
      >
        <template #default="scope">
          <el-tag
            v-if="scope.row.type"
            :key="'VLA'"
            :type="dataUsageTypeListColorMap[scope.row.type]"
            size="small"
            effect="plain"
          >
            {{ dataUsageTypeListMap[scope.row.type] }}
          </el-tag>
          {{ scope.row.taskName }}
        </template>
      </el-table-column>
      <el-table-column
        prop="site"
        :label="$t('eIoT.transmit.location')"
      >
      <template #default="scope"> 
        <span>{{ [scope.row?.site, scope.row?.scene, scope.row?.station, scope.row?.unit].filter(v => v?.trim()).join('_') }}</span>
      </template>
      </el-table-column>
      <el-table-column
        prop="collector"
        :label="$t('eIoT.transmit.collector')"
      />
      <el-table-column
        prop="collectTime"
        :label="$t('eIoT.transmit.collectTime')"
      />
      <el-table-column
        prop="uploadTime"
        :label="$t('eIoT.transmit.uploadTime')"
      />
      <el-table-column prop="fileSize" :label="'' || $t('eIoT.transmit.size')">
        <template #default="scope">
          {{ `${scope.row.fileSize} MB` }}
        </template>
      </el-table-column>
      <el-table-column
        prop="uploadMethod"
        :label="$t('eIoT.deviceConfig.uploadMethod')"
      >
        <template #default="scope">
          <!-- 上传方式，0-直联，1-边端 -->
          <el-tag v-if="scope.row.uploadMethod">{{
            $t('eIoT.deviceConfig.edgeEndpoint')
          }}</el-tag>
          <el-tag v-else type="success">{{
            $t('eIoT.deviceConfig.directConnection')
          }}</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="edgeCode" :label="$t('eIoT.deviceConfig.edgeCode')" /> -->
      <el-table-column
        prop="fileIntegrity"
        :label="$t('eIoT.transmit.integrity')"
      >
        <template #default="scope">
          <!-- 上传方式，0-直联，1-边端 -->
          <!-- v-if="scope.row.fileIntegrity == 2" -->
          <el-tag type="success">
            <i class="el-icon-success"></i>
            {{ $t('eIoT.transmit.complete') }}
          </el-tag>
          <!-- <el-tag v-if="scope.row.fileIntegrity == 3" type="warning">
            <i class="el-icon-refresh"></i>
            {{$t('eIoT.transmit.reupload')}}
          </el-tag>
          <el-tag v-if="scope.row.fileIntegrity == 1" type="danger">
            <i class="el-icon-warning"></i>
            {{$t('eIoT.transmit.missing')}}
          </el-tag> -->
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('activity.list.operation')"
        width="100px"
        fixed="right"
      >
        <template #default="scope">
          <!-- <el-tooltip class="item" effect="dark" :content="$t('eIoT.deviceConfig.uploadFile')">
            <i @click="uploadFile(scope.row)" class="iconfont icon-ota-shangchuan1" :style="`color: ${scope.row.edgeLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 18px`"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('eIoT.transmit.reuploadMissingFiles')">
            <i @click="viewUploaded(scope.row)" class="el-icon-refresh" :style="`color: ${scope.row.edgeLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 21px`"></i>
          </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" :content="$t('eIoT.transmit.viewDetails')">
            <i @click="uploadFile(scope.row)" class="iconfont icon-ota-eyeopen" :style="`color: ${scope.row.edgeLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 21px`"></i>
          </el-tooltip> -->
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('eIoT.transmit.download')"
          >
            <i
              @click="exportPackageData(scope.row)"
              class="iconfont icon-ota-xiazai"
              :style="`color: #9E9E9E;font-size: 18px;cursor: pointer;`"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </Table>
    <el-dialog
      v-model="dialogFormVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
    >
      <el-form
        ref="formRef"
        class="dialog-form"
        :model="form"
        :rules="formRules"
        :label-width="
          curLang == 'zh-CN' ? '120px' : curLang == 'en-US' ? '165px' : '165px'
        "
      >
        <el-form-item
          :label="$t('equipment.cabinet.ctrlCode')"
          prop="cabinetId"
        >
          <el-input v-model="form.cabinetId"></el-input>
        </el-form-item>
        <!-- <el-form-item label="产品名称">
          <el-input v-model="form.modelId" placeholder="产品名称" />
        </el-form-item> -->
        <!-- <el-form-item label="规格型号" prop="modelName">
          <el-input v-model="form.modelName" placeholder="规格型号" />
        </el-form-item> -->
        <!-- <el-form-item label="公司名称">
          <el-input v-model="form.companyName" placeholder="公司名称" />
        </el-form-item> -->
        <!-- <el-form-item label="机器人名称">
          <el-input v-model="form.robotName" placeholder="机器人名称" />
        </el-form-item> -->
        <el-form-item :label="$t('equipment.cabinet.robotLocation')">
          <el-row>
            <el-col :span="6">
              <el-select
                v-model="form.country"
                :placeholder="$t('equipment.cabinet.country')"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select
                v-model="form.province"
                :placeholder="$t('equipment.cabinet.province')"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select
                v-model="form.city"
                :placeholder="$t('equipment.cabinet.city')"
              >
                <el-option
                  v-for="item in formCityList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select
                v-model="form.area"
                :placeholder="$t('equipment.cabinet.district')"
              >
                <el-option
                  v-for="item in formAreaList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-input
            v-model="form.location"
            :placeholder="$t('equipment.cabinet.robotAddress')"
          />
        </el-form-item>
        <!-- <el-form-item label="是否接入OTA" prop="ota">
          <el-select v-model="form.ota" placeholder="是否接入OTA">
            <el-option
              v-for="item in options"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('equipment.cabinet.robotProdTime')">
          <el-date-picker
            v-model="form.produceTime"
            type="date"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('equipment.cabinet.robotProdTime')"
          />
        </el-form-item>
        <el-form-item :label="$t('equipment.cabinet.robotOutboundTime')">
          <el-date-picker
            v-model="form.ledgerBatch"
            type="date"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('equipment.cabinet.robotOutboundTime')"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="small" @click="onSubmit">{{
          $t('activity.list.confirm')
        }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request, downloadFile } from '@/utils/request'
import { reqPackageDownload } from '@/api/resource'
import { common } from '../../common/mixin'
import Table from '@/components/table/index'
import Filter from '@/components/table/filter'
import { ElMessage } from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import {
  taskCategoryList,
  dataUsageTypeList,
  dataUsageTypeListMap,
  dataUsageTypeListColorMap
} from '@/common/constant'

import useDict from './useDict'

// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
import { computed } from 'vue'
import { useStore } from 'vuex'
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data () {
    const store = useStore()
    const route = useRoute()
    const deviceType = route.query.deviceType
    const deviceCode = route.query.deviceCode
    const taskId = route.query.taskId
    const { skillsList, endToolList, endToolMap } = useDict()
    return {
      dialogFormVisible: false,
      formRef: null,
      form: {
        cabinetId: '',
        cabinetName: '',
        // modelName: "",
        location: '',
        country: 80,
        province: '',
        city: '',
        area: '',
        // ota: "",
        produceTime: '',
        ledgerBatch: ''
      },
      formRules: {
        cabinetId: {
          required: true,
          message: this.$t('equipment.cabinet.enterCtrlCode'),
          trigger: 'blur'
        }
        // modelName: {
        //   required: true,
        //   message: '请输入规格型号',
        //   trigger: 'blur',
        // },
        // ota: {
        //   required: true,
        //   message: '请选择是否接入OTA',
        //   trigger: 'change'
        // }
      },
      params: [
        {
          key: 'keyword',
          value: '',
          label: this.$t('eIoT.transmit.keyword')
        },
        {
          type: 'Select',
          key: 'type',
          value: '',
          label: this.$t('eIoT.transmit.dataUsageType'),
          options: {
            data: dataUsageTypeList
            // label: 'name',
            // value: 'value'
          }
        },
        {
          type: 'Select',
          key: 'taskCategory',
          value: '',
          label: this.$t('eIoT.transmit.taskType'),
          options: {
            data: taskCategoryList
            // label: 'name',
            // value: 'value'
          }
        },
        {
          key: 'taskId',
          value: taskId || '',
          label: this.$t('eIoT.transmit.taskId')
        },
        {
          key: 'taskName',
          value: '',
          label: this.$t('eIoT.transmit.taskName')
        },
        {
          key: 'uuid',
          value: deviceType == 1 ? deviceCode : '',
          label: 'uuid'
        },
        {
          key: 'robotSn',
          value: '',
          label: this.$t('eIoT.transmit.robotCode')
        },
        // {
        //   key: 'robotName',
        //   value: '',
        //   label: this.$t('eIoT.transmit.robotName')
        // },
        {
          type: 'Select',
          key: 'endTool',
          value: '',
          label: this.$t('eIoT.transmit.endTool'),
          options: {
            data: endToolList,
            label: 'dictLabel',
            value: 'dictCode'
          }
        },
        {
          key: 'site',
          value: '',
          label: this.$t('eIoT.transmit.site')
        },
        {
          key: 'scene',
          value: '',
          label: this.$t('eIoT.transmit.scene')
        },
        {
          key: 'station',
          value: '',
          label: this.$t('eIoT.transmit.station')
        },
        {
          key: 'unit',
          value: '',
          label: this.$t('eIoT.transmit.unit')
        },
        {
          key: 'fileName',
          value: '',
          label: this.$t('eIoT.transmit.dataPackageName')
        },
        {
          key: 'taskDescription',
          value: '',
          label: this.$t('eIoT.transmit.taskDesc')
        },
        {
          type: 'Select',
          key: 'skill',
          value: '',
          label: this.$t('eIoT.transmit.skill'),
          options: {
            data: skillsList,
            label: 'dictLabel',
            value: 'dictCode'
          },
          attrs: {
            multiple: false,
            filterable: true,
            collapseTags: true
          }
        },
        // {
        //   key: 'skill',
        //   value: '',
        //   label: '技能' || this.$t('eIoT.transmit.robotCode')
        // },
        {
          key: 'collector',
          value: '',
          label: this.$t('eIoT.transmit.collector')
        },
        {
          key: 'subTaskCount',
          value: '',
          label: this.$t('eIoT.transmit.targetCount')
        },
        {
          type: '',
          key: 'edgeCode',
          value: deviceType == 2 ? deviceCode : '',
          label: this.$t('eIoT.deviceConfig.edgeCode')
        },
        {
          type: 'Select',
          key: 'uploadMethod',
          value: '',
          label: this.$t('eIoT.deviceConfig.uploadMethod'),
          options: {
            data: [
              { name: this.$t('eIoT.deviceConfig.directConnection'), value: 0 },
              { name: this.$t('eIoT.deviceConfig.edgeEndpoint'), value: 1 }
            ],
            label: 'name',
            value: 'value'
          }
        },
        {
          type: 'Date',
          key: 'collectTimeRange',
          value: [],
          label: this.$t('eIoT.transmit.collectTime'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': this.$t('activity.detail.to'),
            'start-placeholder': this.$t('activity.list.startDate'),
            'end-placeholder': this.$t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        },
        {
          type: 'Date',
          key: 'uploadTimeRange',
          value: [],
          label: this.$t('eIoT.transmit.uploadTime'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': this.$t('activity.detail.to'),
            'start-placeholder': this.$t('activity.list.startDate'),
            'end-placeholder': this.$t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        }
      ],
      query: {
        uuid: deviceType == 1 ? deviceCode : '',
        edgeCode: deviceType == 2 ? deviceCode : '',
        taskId: taskId || ''
      },
      page: 1,
      size: 10,
      total: 0,
      currentPage: 0,
      tableDataList: [],
      countryList: [
        {
          nameCn: this.$t('equipment.cabinet.china'),
          nameEn: 'China',
          regionId: '80'
        }
      ],
      provinceList: [],
      cityList: [],
      areaList: [],
      formCityList: [],
      formAreaList: [],
      options: [
        {
          id: true,
          name: this.$t('activity.detail.yes')
        },
        {
          id: false,
          name: this.$t('activity.detail.no')
        }
      ],
      curLang: computed(() => store.state.lang),
      userInfo: {},
      authList: JSON.parse(window.localStorage.getItem('authList')),
      deviceType: deviceType,
      deviceCode: deviceCode,
      dataUsageTypeListColorMap: dataUsageTypeListColorMap,
      dataUsageTypeListMap: dataUsageTypeListMap,
      endToolMap: endToolMap
    }
  },
  watch: {
    'query.province': function (value, old) {
      if (value && value !== old) {
        console.log('province', value)
        request('getArea', {
          parentId: Number(value)
        }).then(data => {
          this.cityList = data
        })
      }
    },
    'query.city': function (value, old) {
      if (value && value !== old) {
        request('getArea', {
          parentId: Number(value)
        }).then(data => {
          this.areaList = data
        })
      }
    },
    'form.province': function (value, old) {
      if (value && value !== old) {
        console.log('province', value)
        request('getArea', {
          parentId: Number(value)
        }).then(data => {
          this.formCityList = data
        })
      }
    },
    'form.city': function (value, old) {
      if (value && value !== old) {
        request('getArea', {
          parentId: Number(value)
        }).then(data => {
          this.formAreaList = data
        })
      }
    }
  },
  created () {
    this.getData()
    this.getDataMap()
    try {
      const userInfo = window.localStorage.getItem('userInfo')
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo) || {}
      }
    } catch (error) {
      console.error(error)
    }
  },
  mounted () {},
  methods: {
    getData () {
      if (this.query.dateRange?.length) {
        this.query.ledgerBatchStart = this.query.dateRange[0]
        this.query.ledgerBatchEnd = this.query.dateRange[1]
      } else {
        this.query.ledgerBatchStart = undefined
        this.query.ledgerBatchEnd = undefined
      }
      request('uploadFinishedList', {
        ...this.query,
        page: this.page,
        size: this.size
      })
        .then(data => {
          this.tableDataList = data.records
          this.total = data.total
          // this.tableDataList = data || [];
          // this.total = data.length;
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDataMap () {
      try {
        request('getArea', {
          parentId: 1
        }).then(data => {
          this.provinceList = data
        })
        // request("getRobotStatusMap").then((data) => {
        //   this.robotStatusList = data;
        // });
        // request("getIndustryList").then((data) => {
        //   this.industryList = data;
        // });
      } catch (error) {
        console.log(error)
      }
    },
    searchData (data) {
      this.query = data
      this.getData()
    },
    updatePage (page, size) {
      this.page = page || 1
      this.size = size || 10
      this.getData()
    },
    addNewRobot () {
      for (let key of Object.keys(this.form)) {
        this.form[key] = ''
      }
      this.dialogFormVisible = true
      console.log(this.form)
    },
    editRobot (data) {
      for (let key of Object.keys(this.form)) {
        if (data[key]) {
          this.form[key] = data[key]
        } else {
          this.form[key] = ''
        }
      }
      this.form.ota = data.ota
      this.form.id = data.id
      this.dialogFormVisible = true
      console.log(this.form)
      return
    },
    handleClick (row) {
      this.form = row
      this.dialogFormVisible = true
    },
    async onSubmit () {
      try {
        this.$refs.formRef && (await this.$refs.formRef.validate())
        const api = this.form.id ? 'updateCabinet' : 'addCabinet'
        await request(api, this.form)
        ElMessage({
          showClose: true,
          type: 'success',
          message: this.$t('activity.list.submitSuccess')
        })
        this.dialogFormVisible = false
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    onCancel () {
      this.dialogFormVisible = false
    },
    selectable (row) {
      if (row.isShow == 1) {
        return false
      } else {
        return true
      }
    },
    handleSelect (data) {
      this.batchDataList = data.map(item => {
        return item.id
      })
    },
    // 数据集下载
    async exportPackageData (row) {
      try {
        const res = await reqPackageDownload({ id: row.id })
        // await downloadFile("packageDownload", {}, {
        //   method: 'GET',
        //   params: { id: row.id }
        // });
        window.open(res.data.data)
        // let blob = new Blob([res],{type: "application/octet-stream"})
        // let reader = new FileReader();
        // reader.readAsDataURL(res.data);
        // reader.onload = (e) => {
        //   const a = document.createElement('a')
        //   a.download = row.decodeFileName
        //   a.href = e.target.result
        //   a.click()
        // }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
